import { User } from "@shared/lib/types/auth";
import { User as FirebaseUser } from "firebase/auth";

export const formatUser = (firebaseUser: FirebaseUser): User => ({
  uid: firebaseUser.uid,
  email: firebaseUser.email,
  displayName: firebaseUser.displayName,
  photoURL: firebaseUser.photoURL,
});
